import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { FieldsetModule } from 'primeng/fieldset';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { DatePickerModule } from 'primeng/datepicker';
import { TooltipModule } from 'primeng/tooltip';
import { Oficina } from 'src/app/domain/model/catalogo/oficina';
import { FiltrosCumplimiento } from './filtros-cumplimiento.model';
import { sanitizeText } from 'src/app/common/input-utils';

/**
 * DUMB COMPONENT: FiltrosCumplimiento
 * Muestra los filtros de busqueda para cumplimientos programados.
 * Replica EXACTAMENTE el legacy: FilterOrdenesProgViewImpl.java
 */
@Component({
  selector: 'app-filtros-cumplimiento',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    FieldsetModule,
    InputTextModule,
    DropdownModule,
    DatePickerModule,
    TooltipModule
  ],
  template: `
    <p-fieldset
      legend="Filtros de Consulta"
      [toggleable]="true"
      styleClass="mb-4"
    >
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        <!-- Orden de Servicio -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1"
            >Orden de Servicio</label
          >
          <input
            pInputText
            [ngModel]="filtro().ordenServicio"
            (ngModelChange)="actualizarCampo('ordenServicio', sanitizeText($event))"
            placeholder="Numero de orden..."
            class="w-full"
          />
        </div>
        <!-- Fecha Inicial -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1"
            >Fecha Inicial Programacion</label
          >
          <p-datepicker
            [ngModel]="fechaInicial()"
            (ngModelChange)="fechaInicialChange.emit($event)"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            [style]="{ width: '100%' }"
            appendTo="body"
            [showTransitionOptions]="'0ms'"
            [hideTransitionOptions]="'0ms'"
          >
          </p-datepicker>
        </div>
        <!-- Fecha Final -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1"
            >Fecha Final Programacion</label
          >
          <p-datepicker
            [ngModel]="fechaFinal()"
            (ngModelChange)="fechaFinalChange.emit($event)"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            [style]="{ width: '100%' }"
            appendTo="body"
            [showTransitionOptions]="'0ms'"
            [hideTransitionOptions]="'0ms'"
          >
          </p-datepicker>
        </div>
        <!-- Oficina -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1"
            >Oficina</label
          >
          <p-dropdown
            [ngModel]="filtro().cdoficina"
            (ngModelChange)="actualizarCampo('cdoficina', $event)"
            [options]="oficinas()"
            optionLabel="dsoficina"
            optionValue="nmconsecutivo"
            placeholder="Seleccione..."
            [showClear]="true"
            [filter]="true"
            filterBy="dsoficina"
            appendTo="body"
            [style]="{ width: '100%' }"
          >
          </p-dropdown>
        </div>
        <!-- Unidad Administrativa (lupa) -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1"
            >Unidad Administrativa</label
          >
          <div class="flex gap-1 min-w-0">
            <input
              pInputText
              [ngModel]="filtro().unidadAdministrativa?.descripcion"
              placeholder="Seleccione..."
              readonly
              class="flex-1 min-w-0 cursor-pointer"
              (click)="buscarUnidadAdministrativa.emit()"
            />
            <button
              pButton
              icon="pi pi-search"
              class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
              pTooltip="Buscar"
              (click)="buscarUnidadAdministrativa.emit()"
            ></button>
            @if (filtro().unidadAdministrativa?.id) {
              <button
                pButton
                icon="pi pi-times"
                class="p-button-text p-button-danger min-w-[44px] min-h-[44px]"
                pTooltip="Limpiar"
                (click)="limpiarCampo('unidadAdministrativa')"
              ></button>
            }
          </div>
        </div>
        <!-- Nombre Tarea (lupa) -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1"
            >Nombre Tarea</label
          >
          <div class="flex gap-1 min-w-0">
            <input
              pInputText
              [ngModel]="filtro().tarea?.descripcion"
              placeholder="Seleccione..."
              readonly
              class="flex-1 min-w-0 cursor-pointer"
              (click)="buscarTarea.emit()"
            />
            <button
              pButton
              icon="pi pi-search"
              class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
              pTooltip="Buscar"
              (click)="buscarTarea.emit()"
            ></button>
            @if (filtro().tarea?.id) {
              <button
                pButton
                icon="pi pi-times"
                class="p-button-text p-button-danger min-w-[44px] min-h-[44px]"
                pTooltip="Limpiar"
                (click)="limpiarCampo('tarea')"
              ></button>
            }
          </div>
        </div>
        <!-- Consultor (IdentificationViewImpl) -->
        <div
          class="col-span-full border rounded p-3 bg-gray-50 dark:bg-gray-800 dark:border-gray-700"
        >
          <label class="block text-sm font-medium text-gray-700 mb-2"
            >Consultor</label
          >
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div class="sm:col-span-1">
              <label class="block text-xs text-gray-500 mb-1"
                >Identificacion</label
              >
              <div class="flex gap-1 items-center">
                <input
                  pInputText
                  [ngModel]="filtro().consultor?.codigo"
                  readonly
                  class="flex-1 min-w-0"
                />
                @if (!esAsesor()) {
                  <button
                    pButton
                    icon="pi pi-search"
                    class="p-button-outlined p-button-sm shrink-0 min-w-[44px] min-h-[44px]"
                    pTooltip="Buscar consultor"
                    (click)="buscarConsultor.emit()"
                  ></button>
                }
                @if (filtro().consultor?.id && !esAsesor()) {
                  <button
                    pButton
                    icon="pi pi-times"
                    class="p-button-text p-button-danger p-button-sm shrink-0 min-w-[44px] min-h-[44px]"
                    pTooltip="Limpiar"
                    (click)="limpiarCampo('consultor')"
                  ></button>
                }
              </div>
            </div>
            @if (filtro().consultor?.id) {
              @if (esConsultorNit()) {
                <div class="sm:col-span-2">
                  <label class="block text-xs text-gray-500 mb-1">Nombre</label>
                  <input
                    pInputText
                    [ngModel]="filtro().consultor?.nombreComercial"
                    readonly
                    class="w-full"
                  />
                </div>
              } @else {
                <div class="sm:col-span-2"></div>
                <div>
                  <label class="block text-xs text-gray-500 mb-1"
                    >1er nombre</label
                  >
                  <input
                    pInputText
                    [ngModel]="filtro().consultor?.nombre1"
                    readonly
                    class="w-full"
                  />
                </div>
                <div>
                  <label class="block text-xs text-gray-500 mb-1"
                    >2do nombre</label
                  >
                  <input
                    pInputText
                    [ngModel]="filtro().consultor?.nombre2"
                    readonly
                    class="w-full"
                  />
                </div>
                <div>
                  <label class="block text-xs text-gray-500 mb-1"
                    >1er apellido</label
                  >
                  <input
                    pInputText
                    [ngModel]="filtro().consultor?.apellido1"
                    readonly
                    class="w-full"
                  />
                </div>
                <div>
                  <label class="block text-xs text-gray-500 mb-1"
                    >2do apellido</label
                  >
                  <input
                    pInputText
                    [ngModel]="filtro().consultor?.apellido2"
                    readonly
                    class="w-full"
                  />
                </div>
              }
            }
          </div>
        </div>
        <!-- Aseguradora (IdentificationViewImpl) -->
        <div
          class="col-span-full border rounded p-3 bg-gray-50 dark:bg-gray-800 dark:border-gray-700"
        >
          <label class="block text-sm font-medium text-gray-700 mb-2"
            >Aseguradora</label
          >
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div>
              <label class="block text-xs text-gray-500 mb-1"
                >Identificacion</label
              >
              <div class="flex gap-1 items-center">
                <input
                  pInputText
                  [ngModel]="filtro().aseguradora?.codigo"
                  readonly
                  class="flex-1 min-w-0 cursor-pointer"
                  (click)="buscarAseguradora.emit()"
                />
                <button
                  pButton
                  icon="pi pi-search"
                  class="p-button-outlined p-button-sm shrink-0 min-w-[44px] min-h-[44px]"
                  pTooltip="Buscar"
                  (click)="buscarAseguradora.emit()"
                ></button>
                @if (filtro().aseguradora?.id) {
                  <button
                    pButton
                    icon="pi pi-times"
                    class="p-button-text p-button-danger p-button-sm shrink-0 min-w-[44px] min-h-[44px]"
                    pTooltip="Limpiar"
                    (click)="limpiarCampo('aseguradora')"
                  ></button>
                }
              </div>
            </div>
            <div>
              <label class="block text-xs text-gray-500 mb-1">Nombre</label>
              <input
                pInputText
                [ngModel]="filtro().aseguradora?.nombreComercial"
                readonly
                class="w-full"
              />
            </div>
          </div>
        </div>
        <!-- Cliente (lupa) -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1"
            >Cliente</label
          >
          <div class="flex gap-1 min-w-0">
            <input
              pInputText
              [ngModel]="filtro().cliente?.descripcion"
              placeholder="Seleccione..."
              readonly
              class="flex-1 min-w-0 cursor-pointer"
              (click)="buscarCliente.emit()"
            />
            <button
              pButton
              icon="pi pi-search"
              class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
              pTooltip="Buscar"
              (click)="buscarCliente.emit()"
            ></button>
            @if (filtro().cliente?.id) {
              <button
                pButton
                icon="pi pi-times"
                class="p-button-text p-button-danger min-w-[44px] min-h-[44px]"
                pTooltip="Limpiar"
                (click)="limpiarCampo('cliente')"
              ></button>
            }
          </div>
        </div>
        <!-- Centro de Trabajo (lupa) -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1"
            >Centro de Trabajo</label
          >
          <div class="flex gap-1 min-w-0">
            <input
              pInputText
              [ngModel]="filtro().centroTrabajo?.descripcion"
              placeholder="Buscar centro de trabajo..."
              readonly
              class="flex-1 min-w-0 cursor-pointer"
              (click)="onBuscarCentroTrabajo()"
            />
            <button
              pButton
              icon="pi pi-search"
              class="p-button-outlined p-button-sm min-w-[44px] min-h-[44px]"
              pTooltip="Buscar"
              (click)="onBuscarCentroTrabajo()"
            ></button>
            @if (filtro().centroTrabajo?.id) {
              <button
                pButton
                icon="pi pi-times"
                class="p-button-text p-button-danger min-w-[44px] min-h-[44px]"
                pTooltip="Limpiar"
                (click)="limpiarCampo('centroTrabajo')"
              ></button>
            }
          </div>
        </div>
      </div>
      <!-- Botones centrados debajo de Cliente y Centro de Trabajo -->
      <div
        class="flex flex-wrap justify-end sm:justify-start gap-2 sm:gap-3 mt-4 w-full"
      >
        <button
          pButton
          label="Limpiar"
          icon="pi pi-eraser"
          class="p-button-secondary p-button-outlined"
          (click)="limpiar.emit()"
        ></button>
        <button
          pButton
          label="Buscar"
          icon="pi pi-search"
          class="p-button-primary"
          [loading]="loading()"
          (click)="buscar.emit()"
        ></button>
      </div>
    </p-fieldset>
  `
})
export class FiltrosCumplimientoComponent {
  sanitizeText = sanitizeText;
  oficinas = input<Oficina[]>([]);
  loading = input<boolean>(false);
  filtro = input<FiltrosCumplimiento>({});
  fechaInicial = input<Date | null>(null);
  fechaFinal = input<Date | null>(null);
  /** Legacy: Si usuario es tipo ASESOR, se precargan SUS datos en Consultor y se OCULTA la lupa */
  esAsesor = input<boolean>(false);

  filtroChange = output<FiltrosCumplimiento>();
  fechaInicialChange = output<Date | null>();
  fechaFinalChange = output<Date | null>();
  buscar = output<void>();
  limpiar = output<void>();
  buscarUnidadAdministrativa = output<void>();
  buscarTarea = output<void>();
  buscarConsultor = output<void>();
  buscarAseguradora = output<void>();
  buscarCliente = output<void>();
  buscarCentroTrabajo = output<void>();

  actualizarCampo(campo: keyof FiltrosCumplimiento, valor: any): void {
    this.filtroChange.emit({ ...this.filtro(), [campo]: valor });
  }

  limpiarCampo(campo: keyof FiltrosCumplimiento): void {
    if (campo === 'consultor' && this.esAsesor()) return;
    const nuevoFiltro = { ...this.filtro() };
    if (campo === 'cliente') {
      nuevoFiltro.cliente = undefined;
      nuevoFiltro.centroTrabajo = undefined;
    } else {
      (nuevoFiltro as any)[campo] = undefined;
    }
    this.filtroChange.emit(nuevoFiltro);
  }

  onBuscarCentroTrabajo(): void {
    this.buscarCentroTrabajo.emit();
  }

  esConsultorNit(): boolean {
    return ((this.filtro().consultor as any)?.tipoIdentificacion ?? '') === 'N';
  }
}
